// Route Constants - Centralized route management
export const ROUTES = {
  // Public Routes
  HOME: '/',
  DOG_TRAINING_CHALLENGE: '/dog-training-challenge',

  MEMBERSHIP: '/membership',
  VIP_MEMBER: '/vip-member',
  THANK_YOU: '/thank-you',
  CHALLENGES: '/challenges',
  CHALLENGE: '/challenge',
  ONBOARDING: '/onboarding',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  
  // Legal Pages
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_OF_SERVICE: '/terms-of-service',
  COOKIE_POLICY: '/cookie-policy',
  ACCESSIBILITY: '/accessibility',
  
  // Support Pages
  HELP: '/help',
  FAQ: '/faq',
  SITEMAP: '/sitemap',
  UNSUBSCRIBE: '/unsubscribe',
  
  // Auth Routes
  AUTH_REDIRECT: '/auth/redirect',
  
  // Private Routes (require authentication)
  FAST_START: '/fast-start',
  PERSONALIZED_PLAN_QUIZ: '/personalized-plan-quiz',
  PERSONALIZED_PLAN: '/personalized-plan',
  PURCHASES: '/purchases',
  ACTIVE_CHALLENGE: '/active-challenge',
  CHALLENGE_TIMELINE: '/challenge-timeline',
  DASHBOARD: '/dashboard',
  SKILLS: '/skills',
  ADD_DOG: '/add-dog',
  TRAINER: '/trainer',
  RATE: '/rate',
  SUBSCRIPTION: '/subscription',
  SUBSCRIPTION_SUCCESS: '/subscription-success',
  SUBSCRIPTION_CANCEL: '/subscription-cancel',
  MY_MEMBERSHIP: '/my-membership',
  EDIT_PROFILE: '/edit-profile',
  
  // Development/Testing Routes
  EMAIL_TEST: '/email-test',
  
  // Fallback
  NOT_FOUND: '*'
};

// Route Categories for organization
export const ROUTE_CATEGORIES = {
  PUBLIC: [
    ROUTES.HOME,
    ROUTES.DOG_TRAINING_CHALLENGE,

    ROUTES.MEMBERSHIP,
    ROUTES.VIP_MEMBER,
    ROUTES.THANK_YOU,
    ROUTES.CHALLENGES,
    ROUTES.CHALLENGE,
    ROUTES.ONBOARDING,
    ROUTES.LOGIN,
    ROUTES.FORGOT_PASSWORD
  ],
  LEGAL: [
    ROUTES.PRIVACY_POLICY,
    ROUTES.TERMS_OF_SERVICE,
    ROUTES.COOKIE_POLICY,
    ROUTES.ACCESSIBILITY
  ],
  SUPPORT: [
    ROUTES.HELP,
    ROUTES.FAQ,
    ROUTES.SITEMAP,
    ROUTES.UNSUBSCRIBE
  ],
  PRIVATE: [
    ROUTES.FAST_START,
    ROUTES.PERSONALIZED_PLAN_QUIZ,
    ROUTES.PERSONALIZED_PLAN,
    ROUTES.PURCHASES,
    ROUTES.ACTIVE_CHALLENGE,
    ROUTES.CHALLENGE_TIMELINE,
    ROUTES.DASHBOARD,
    ROUTES.SKILLS,
    ROUTES.ADD_DOG,
    ROUTES.TRAINER,
    ROUTES.RATE,
    ROUTES.SUBSCRIPTION,
    ROUTES.SUBSCRIPTION_SUCCESS,
    ROUTES.SUBSCRIPTION_CANCEL,
    ROUTES.MY_MEMBERSHIP,
    ROUTES.EDIT_PROFILE
  ],
  AUTH: [
    ROUTES.AUTH_REDIRECT
  ],
  DEVELOPMENT: [
    ROUTES.EMAIL_TEST
  ]
};

// Routes that don't show the NavBar
export const ROUTES_WITHOUT_NAVBAR = [
  ROUTES.ONBOARDING,
  ROUTES.TRAINER,
  ROUTES.LOGIN,
  ROUTES.SUBSCRIPTION,
  ROUTES.RATE,
  ROUTES.FORGOT_PASSWORD,
  ROUTES.DOG_TRAINING_CHALLENGE,
  ROUTES.FAST_START,
  ROUTES.MEMBERSHIP,
  ROUTES.VIP_MEMBER,

  ROUTES.PERSONALIZED_PLAN_QUIZ,
  ROUTES.ADD_DOG,
  ROUTES.UNSUBSCRIBE
];

// Routes that require VIP membership
export const VIP_ROUTES = [
  ROUTES.VIP_MEMBER,
  // Add other VIP-only routes here
];

// Routes that require subscription
export const SUBSCRIPTION_ROUTES = [
  ROUTES.SUBSCRIPTION,
  ROUTES.SUBSCRIPTION_SUCCESS,
  ROUTES.SUBSCRIPTION_CANCEL,
  // Add other subscription-only routes here
]; 